import { resolve } from 'path';
import { EmptyGuid } from '../emptyGuid';
import { PageState } from './bootgridTypes';
import { RecordPageViewApi } from './ViewManager/ViewApi/RecordPageViewApi';


export class PageStateConstructor {
    async constructPageStateFromPageView(pageView: string | null): Promise<PageState> {
        const recordPageViewApi = new RecordPageViewApi();
        const pageViewData = await recordPageViewApi.getView(pageView);
        return {
            selectedSubMenuItemId: null,
            selectedPageView: pageView,
            selectedGridViews: pageViewData.BootgridViews,
            selectedRows: null
        };
    }
    construct(): PageState {
        return {
            selectedSubMenuItemId: this.getSelectedSubMenuItemId(),
            selectedPageView: this.getSelectedValue(),
            selectedGridViews: this.getSelectedGridViews(),
            selectedRows: this.getSelectedRows(),
        };
    }
    getSelectedRows(): Record<string, string> {
        const tableContainers = document.querySelectorAll('.table-container');
        let selectedRows: Record<string, string> = {};
        tableContainers.forEach((tableContainer) => {
            const selectedRow = tableContainer.querySelector('tbody > tr.row_selected');
            if (selectedRow === undefined || selectedRow === null) return;
            const rowId = selectedRow.getAttribute('data-row-id');
            if (rowId === undefined || rowId === null) return;
            const bootgridId = $(tableContainer).find('table').data('menu-item-name');
            if (bootgridId === undefined || bootgridId === null) return;
            selectedRows[bootgridId] = rowId;
        });
        return selectedRows;
    }
    getSelectedValue(): string {
        const viewManagerContainer = document.querySelector('.page-head .view-manager');
        if (viewManagerContainer === undefined || viewManagerContainer === null) return;

        const selectElement = viewManagerContainer.querySelector('select');
        return $(selectElement).val()?.toString();
    }
    getSelectedGridViews(): Record<string, string> {
        let selectedGridViews: Record<string, string> = {};
        const tableContainers = document.querySelectorAll('.table-container');
        tableContainers.forEach((tableContainer) => {
            const viewManagerContainer = tableContainer.querySelector('.view-manager');
            if (viewManagerContainer === undefined || viewManagerContainer === null) return;

            const selectElement = viewManagerContainer.querySelector('select');
            const selectedValue = $(selectElement).val()?.toString();
            const bootgridMenuItemName = $(tableContainer).find('table').data("menu-item-name");
            selectedGridViews[bootgridMenuItemName] = selectedValue;
        });
        return selectedGridViews;
    }
    getSelectedSubMenuItemId() {
        const subTablesContainer = $('#bottomTabContainer').parent();
        const activeSubTableContainer = subTablesContainer.find('.table-container.active');
        let activeSubMenuItemId = activeSubTableContainer.find('table').data('luscinia-menuitem-id') as string;
        if (activeSubMenuItemId === undefined || activeSubMenuItemId === null) {
            activeSubMenuItemId = EmptyGuid.value;
        }
        return activeSubMenuItemId;
    }
}
